<template>
    <v-card>
        <loading-component :value="loading"/>
        <v-dialog v-model="action.visible">
            <v-card class="pa-4">
                <v-card-title primary-title class="title font-weight-bold">
                    {{action.title}}
                </v-card-title>
                <v-divider/>
                <v-form ref="actionForm">
                    <choose-date label="Return Date" v-if="action.showReturnDate" v-model="action.form.return_date"/>
                    <template v-if="action.showLeavingReason">
                        <v-radio-group v-model="action.form.leaving_reason" column color="red">
                            <v-radio
                                    v-for="item in $store.state.user.settings.LOST_CAPTAINS_CAUSES"
                                    :label="item"
                                    :value="item"
                                    :key="item"
                            />
                            <v-radio label="Other"
                                     value="other"
                            />
                        </v-radio-group>
                        <v-text-field v-if="action.form.leaving_reason === 'other'" label="Other"
                                      v-model="action.form.other"/>
                    </template>

                    <v-btn @click="doDialogAction" color="primary">
                        Save
                    </v-btn>
                </v-form>
            </v-card>
        </v-dialog>
        <v-tabs grow color="secondary" dark icons-and-text v-model="tab">
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab href="#PENDING">
                Lost Captain
                <v-icon color="white">fa fa-pause</v-icon>
            </v-tab>
            <v-tab href="#RE-GONE">
                Didn't Come back
                <v-icon color="white">fa fa-exclamation</v-icon>
            </v-tab>
            <v-tab href="#RETURNING">
                Pending To Return
                <v-icon color="white">fa fa-repeat</v-icon>
            </v-tab>
            <v-tab href="#GONE">
                Lost For Ever
                <v-icon color="white">fa fa-plane</v-icon>
            </v-tab>
        </v-tabs>
        <data-table
                ref="dataTable"
                :url="api.ACTIONS.LOST_CAPTAINS"
                :initial-url-search-params="params"
                :fields-hidden-main="fieldsHiddenMain"
                :titles="titles"
                :formatter="formatter"
                :fields-extra-main="fieldsExtraMain"
                :actions-extra-main="actionsExtraMain"
                :enable-add="false"
                :enable-edit="false"
                :enable-delete="false"
                sort-by="lost_date"
                descending
        />
    </v-card>


</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, DataTable, ChooseDate},
        name: "LostCaptains",
        title: "Lost Captains",
        data() {
            return {
                loading: false,
                tab: "PENDING",
                action: {
                    visible: false,
                    title: null,
                    showReturnDate: true,
                    showLeavingReason: true,
                    form: {
                        return_date: null,
                        leaving_reason: null,
                        other: null
                    },
                    action: null
                }
            }
        },
        watch: {
            "action.visible"() {
                this.action.form = {
                    return_date: null,
                    leaving_reason: null,
                    other: null
                };
            }
        },
        methods: {
            async doDialogAction() {
                this.loading = true;
                await this.action.action();
                this.loading = false;
            }
        },
        computed: {
            params() {
                const params = new URLSearchParams();
                params.append("filter", this.tab);
                return params;
            },
            fieldsHiddenMain() {
                if (this.tab === "PENDING")
                    return ['status', 'return_date', 'leaving_reason', 'created_at', 'updated_at', 'captain'];
                else if (this.tab === "GONE")
                    return ['status', 'return_date', 'created_at', 'updated_at', 'captain'];
                else
                    return ['status', 'created_at', 'updated_at', 'captain']
            },
            fieldsExtraMain() {
                return {
                    captain_name(val) {
                        return val.captain.first_name + ' ' + val.captain.last_name;
                    }
                }
            },
            actionsExtraMain() {
                const moveToTempGone = (item) => {
                    this.action.visible = true;
                    this.action.title = `Move ${item.captain.first_name} ${item.captain.last_name} To Temp Gone`;
                    this.action.showReturnDate = true;
                    this.action.showLeavingReason = true;
                    this.action.action = async () => {
                        try {
                            const data = {...this.action.form};
                            if (data.leaving_reason === 'other')
                                data.leaving_reason = data.other;
                            data.status = "TEMPORARILY_GONE";
                            await this.axios.put(this.api.ACTIONS.LOST_CAPTAINS + '/' + item.id, data);
                            window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                            this.action.visible = false;
                        } catch (e) {
                            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                        }
                    };
                };

                const moveToPermanentGone = (item) => {
                    this.action.visible = true;
                    this.action.title = `Move ${item.captain.first_name} ${item.captain.last_name} To Permanently Gone Captains`;
                    this.action.showReturnDate = false;
                    this.action.showLeavingReason = true;
                    this.action.action = async () => {
                        try {
                            const data = {...this.action.form};
                            if (data.leaving_reason === 'other')
                                data.leaving_reason = data.other;
                            data.status = "PERMANENTLY_GONE";
                            await this.axios.put(this.api.ACTIONS.LOST_CAPTAINS + '/' + item.id, data);
                            window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                            this.action.visible = false;
                        } catch (e) {
                            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                        }
                    };
                };

                return {
                    moveToTempGone: {
                        title: "Will Return",
                        action: moveToTempGone
                    },
                    moveToPermanentGone: {
                        title: "Won't Return",
                        action: moveToPermanentGone
                    }
                }
            },
            titles() {
                return {
                    return_date: "Returns on",
                    leaving_reason: "Leaving Reason",
                    captain_name: "Captain Name",
                    captain_id: "Captain Id",
                    id: "#",
                    lost_date: "Lost Date",
                    was_online_ever: "Ever Online",
                    avg_rating: "Avg Rating"
                }
            },
            formatter() {
                return {
                    was_online_ever: val => val ? "Yes" : "No",
                    avg_rating: val => val === null ? "N\\A" : val
                }
            }
        }
    }
</script>

<style scoped>

</style>